import { CardProps } from './types';

export const Card: React.FC<CardProps> = ({ className = '', children }) => (
  <div className={`rounded border bg-white shadow-md shadow-gray-400 ${className}`}>{children}</div>
);
